import { CALL_API } from "../../middlewares/api";

export const USER_DATA_FETCH_REQUEST = "USER_DATA_FETCH_REQUEST";
export const USER_DATA_FETCH_SUCCESS = "USER_DATA_FETCH_SUCCESS";
export const USER_DATA_FETCH_ERROR = "USER_DATA_FETCH_ERROR";

export function fetch_user_data() {
  let uri = "/api/admin/utils/userdata";

  return {
    [CALL_API]: {
      endpoint: uri,
      authenticatedRequest: true,
      types: [
        USER_DATA_FETCH_REQUEST,
        USER_DATA_FETCH_SUCCESS,
        USER_DATA_FETCH_ERROR,
      ],
    },
  };
}

export const SET_SESSION_REQUEST = "SET_SESSION_REQUEST";
export const SET_SESSION_SUCCESS = "SET_SESSION_SUCCESS";
export const SET_SESSION_ERROR = "SET_SESSION_ERROR";

export function set_session_minutes(minutes) {
  let uri = "/api/admin/account/setsessiontime";

  return {
    [CALL_API]: {
      endpoint: uri,
      authenticatedRequest: true,
      method: "POST",
      data: { Minutes: minutes },
      types: [SET_SESSION_REQUEST, SET_SESSION_SUCCESS, SET_SESSION_ERROR],
    },
  };
}

export function refresh_token() {
  return (dispatch) => {
    //Use token if it was sent directly from callback method
    let sessionToken = JSON.parse(localStorage.getItem("admin.usr"));
    var postData =
      "grant_type=refresh_token&refresh_token=" +
      sessionToken.refresh_token +
      "&client_id=" +
      reloansysConfig.appVersion;

    dispatch(fetch_token_for_terms(postData));
  };
}

function fetch_token_for_terms(postData) {
  return {
    [CALL_API]: {
      endpoint: "/api/auth/token",
      types: [
        "NOTHIG_HAPENS_REQUEST_TOKEN",
        { method: sucess },
        { method: it_failed },
      ],
      noLoading: true,
      method: "POST",
      contentType: "application/x-www-form-urlencoded",
      data: postData,
    },
  };
}

function it_failed() {
  return {
    type: "NOTHIG_HAPENS_REQUEST_TOKEN",
  };
}

function sucess(token) {
  if (
    typeof document !== "undefined" &&
    typeof sessionStorage !== "undefined"
  ) {
    document.cookie = "BearerToken=" + token.access_token;
    sessionStorage.setItem("admin.usr", JSON.stringify(token));
    localStorage.setItem("admin.usr", JSON.stringify(token));
  }
  return {
    type: "NOTHIG_HAPENS_REQUEST_TOKEN",
  };
}
